import React, { memo } from "react";

function RecordingControls({ isPaused, onPause, onResume, onReset, onFinish }) {
  const Btn = ({ children, label, onClick, aria }) => (
    <div className="flex flex-col items-center">
      <button
        type="button"
        onClick={onClick}
        aria-label={aria}
        className="w-16 h-16 rounded-full bg-gray-900 text-white shadow-lg
                   hover:shadow-xl active:scale-95 transition transform
                   flex items-center justify-center"
      >
        {children}
      </button>
      <span className="mt-2 text-sm text-gray-500">{label}</span>
    </div>
  );

  return (
    <div className="flex items-center gap-8">
      <Btn label="Reset" aria="Reset recording" onClick={onReset}>
        <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M3 2v6h6" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M3.51 15a8 8 0 1 0 .49-9" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Btn>

      {!isPaused ? (
        <Btn label="Pause" aria="Pause recording" onClick={onPause}>
          <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M10 5v14M14 5v14" strokeLinecap="round" />
          </svg>
        </Btn>
      ) : (
        <Btn label="Resume" aria="Resume recording" onClick={onResume}>
          <svg viewBox="0 0 24 24" className="w-7 h-7" fill="currentColor">
            <path d="M8 5v14l11-7-11-7z" />
          </svg>
        </Btn>
      )}

      <Btn label="Finish" aria="Finish and process" onClick={onFinish}>
        <svg viewBox="0 0 24 24" className="w-7 h-7" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M20 6 9 17l-5-5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </Btn>
    </div>
  );
}
export default memo(RecordingControls);
